export const SET_HE_THONG_RAP_CHIEU = 'SET_HE_THONG_RAP_CHIEU';
export const SET_CHI_TIET_PHIM = 'SET_CHI_TIET_PHIM';